/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const contacts = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M10.338 11.857a.75.75 0 1 0 1.498-.077l-1.498.077Zm-3.174-.077a.75.75 0 1 0 1.498.077l-1.498-.077ZM9.5 10.778c.28 0 .45.1.57.245.137.166.248.445.268.834l1.498-.077c-.032-.615-.214-1.231-.607-1.71-.411-.499-1.009-.793-1.729-.793v1.5Zm-.838 1.079c.02-.389.131-.668.268-.834.12-.145.29-.245.57-.245v-1.5c-.72 0-1.318.293-1.729.792-.393.479-.575 1.095-.607 1.71l1.498.077Zm1.997-5.085c0 .68-.535 1.203-1.159 1.203v1.5c1.485 0 2.66-1.227 2.66-2.703h-1.5ZM9.5 7.975c-.624 0-1.16-.522-1.16-1.203h-1.5c0 1.476 1.175 2.703 2.66 2.703v-1.5ZM8.34 6.772c0-.681.536-1.204 1.16-1.204v-1.5c-1.485 0-2.66 1.227-2.66 2.704h1.5ZM9.5 5.568c.624 0 1.16.523 1.16 1.204h1.5c0-1.477-1.175-2.704-2.66-2.704v1.5Zm5.25 8.796V1.636h-1.5v12.728h1.5ZM1.25 1.636v12.728h1.5V1.636h-1.5ZM13.364.25H5v1.5h8.364V.25ZM5 .25H2.636v1.5H5V.25Zm-2.364 15.5H5v-1.5H2.636v1.5Zm2.364 0h8.364v-1.5H5v1.5ZM4.25 1v14h1.5V1h-1.5Zm-1.5.636c0 .063-.05.114-.114.114V.25C1.871.25 1.25.87 1.25 1.636h1.5Zm12 0c0-.765-.62-1.386-1.386-1.386v1.5a.114.114 0 0 1-.114-.114h1.5Zm-1.5 12.728c0-.063.05-.114.114-.114v1.5c.765 0 1.386-.62 1.386-1.386h-1.5Zm-12 0c0 .765.62 1.386 1.386 1.386v-1.5c.063 0 .114.05.114.114h-1.5Z"
    />
  </svg>
)
export default contacts
